import dayjs from "dayjs";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import ConfirmDialog from "../../layouts/confirmDialog/confirmDialog.vue";
import { Roles } from "../../models/emums/roles";
import SupervisorEncoryListRestModel from "../../models/rest/supervisor-encory/supervisorEncoryListRestModel";
import SupervisorEncoryRestModel from "../../models/rest/supervisor-encory/supervisorEncoryRestModel";

@Component({
    components: {
        "confirm-dialog": ConfirmDialog
    }
})
export default class SupervisorEncoryList extends Vue {
    get pagerOptions(): any {
        return this.$store.direct.state.supervisorEncory.supervisorEncoryListPagerOptions;
    }

    set pagerOptions(val: any) {
        this.$store.direct.commit.supervisorEncory.setSupervisorEncoryListPagerOptions(val);
    }
    get supervisorEncoryList(): SupervisorEncoryListRestModel[] {
        const supervisorEncoryList = this.$store.direct.state.supervisorEncory.supervisorEncoryList;

        supervisorEncoryList.forEach((x: SupervisorEncoryListRestModel) => {
            if (x.planned != undefined) {
                const formattedDateTime = this.formatDateTime(x.planned);
                x.planned = formattedDateTime != undefined ? formattedDateTime : x.planned;
            }
        })

        return supervisorEncoryList;
    }

    get supervisorEncoryListLoading(): boolean {
        return this.$store.direct.state.supervisorEncory.supervisorEncoryListLoading;
    }

    get supervisorEncoryListTotalCount(): number {
        return this.$store.direct.state.supervisorEncory.supervisorEncoryListTotalCount;
    }

    get isLoading(): boolean {
        return this.$store.direct.state.loading;
    }

    get currentUserRoles(): string[] {
        return this.$store.direct.state.auth.userRoles;
    }

    get userCanEditCommentsFields(): boolean {
        return (this.currentUserRoles.includes(Roles.Admin) || this.currentUserRoles.includes(Roles.DisponentAdmin) || this.currentUserRoles.includes(Roles.Disponent)) ? true : false;
    }

    headers = [
        {
            text: "Id",
            align: "start",
            value: "id",
            sortable: true
        },
        {
            text: "LoadCarrierNumber",
            align: "start",
            value: "loadCarrierNumber",
            sortable: true
        },
        {
            text: this.$t("supervisorEncory.createdAt"),
            align: "start",
            value: "createdAt",
            sortable: true
        },
        {
            text: "BuNo",
            align: "start",
            value: "dealerShipToNumber",
            sortable: true
        },
        {
            text: this.$t("supervisorEncory.postalCode"),
            align: "start",
            value: "postalCode",
            sortable: true
        },
        {
            text: this.$t("supervisorEncory.city"),
            align: "start",
            value: "city",
            sortable: true
        },
        {
            text: this.$t("supervisorEncory.duration"),
            align: "start",
            value: "duration",
            sortable: false
        },
        {
            text: this.$t("supervisorEncory.supervisorOrderId"),
            align: "start",
            value: "supervisorOrderId",
            sortable: false
        },
        {
            text: this.$t("supervisorEncory.sent"),
            align: "start",
            value: "sent",
            sortable: false
        },
        {
            text: this.$t("supervisorEncory.loaded"),
            align: "start",
            value: "integration",
            sortable: true
        },
        {
            text: this.$t("supervisorEncory.planned"),
            align: "start",
            value: "planned",
            sortable: false
        },
        {
            text: this.$t("supervisorEncory.comment"),
            align: "start",
            value: "comment",
            sortable: false
        },
        {
            text: this.$t("supervisorEncory.carrierComment"),
            align: "start",
            value: "carrierComment",
            sortable: false
        },
        {
            text: this.$t("supervisorEncory.save"),
            align: "center",
            value: "save",
            width: "1%",
            sortable: false
        },
        {
            text: this.$t("common.cancel"),
            align: "center",
            value: "cancel",
            width: "1%",
            sortable: false
        },
    ];

    @Watch("pagerOptions", { deep: true })
    pagerOptionsHandles() {
        this.loadSupervisorEncoryList();
    }

    getEncoryDurationItemStyle(item: SupervisorEncoryListRestModel) {
        const greenTextColor = "green--text ";
        const orangeTextColor = "orange--text ";
        const redTextColor = "red--text ";
        let style = "";

        if (item.duration <= 10) {
            style += greenTextColor;
        }
        else if (item.duration >= 11 && item.duration <= 15) {
            style += orangeTextColor;
        }
        else {
            style += redTextColor;
        }

        return style;
    }

    searchClick() {
        this.loadSupervisorEncoryList();
    }

    async loadSupervisorEncoryList() {
        await this.$store.direct.dispatch.supervisorEncory.loadSupervisorEncoryList({
            page: this.pagerOptions.page,
            sortBy: this.pagerOptions.sortBy[0],
            sortDesc: this.pagerOptions.sortDesc[0],
            itemsPerPage: this.pagerOptions.itemsPerPage
        });
    }

    async saveSupervisorEncoryClick(encory: SupervisorEncoryListRestModel) {
        const encoryModel = {
            id: encory.id,
            planned: encory.planned,
            carrierComment: encory.carrierComment,
            comment: encory.comment
        } as SupervisorEncoryRestModel
        await this.$store.direct.dispatch.supervisorEncory.saveSupervisorEncoryComments({ encory: encoryModel });
    }

    async cancelSupervisorEncoryClick(encory: SupervisorEncoryListRestModel) {
        await this.$store.direct.dispatch.confirm
            .openConfirmDialog({
                showConfirmDialog: true,
                title: `${this.$t("supervisorEncory.cancelSupervisorEncoryTitle")}`,
                message: `${this.$t("supervisorEncory.cancelSupervisorEncorMessage")} ${encory.loadCarrierNumber}`,
                links: [],
                options: { buttonColor: "error", layoutColor: "red" },
                buttonType: "yes/no"
            })
            .then(async confirm => {
                if (confirm) {
                    await this.$store.direct.dispatch.supervisorEncory.cancelSupervisorEncoryClick({ supervisorEncoryHandlingUnitId: encory.id });
                    await this.loadSupervisorEncoryList();
                }
            });
    }

    editSupervisorClick(supervisorId: number) {
        return "/supervisor/edit/" + supervisorId;
    }

    formatDateTime(dateTime: any) {
        if (dateTime != null) {
            return dayjs(dateTime).format("YYYY-MM-DD");
        }
    }
}
